/*
  Maxton-sidorna (release 4, gren r4-maxton): landningssidan (page.dg-maxton) och Maxton-kollektionen
  (collection.dg-maxton).

  Vald bil: läses ur localStorage 'dg_bilval' (sparas av dg-bilval.js). Händelsen 'dg-bilval:bil' ritar om sidan
  när kunden väljer, byter eller tar bort bilen. Väljer kunden bil i panelen på landningssidan stannar hon kvar
  ('dg-bilval:visa' avbryts), och sidan visar bilens delar.

  Kategoribollarna är filter (Tim 2026-10-11): man trycker in en eller flera, och produktlistan visar bara dem.
  "Alla delar" och "Rensa urval" släpper alla. Valet sparas i adressen (?kat=frontlappar,spoilers).
  Produkterna hämtas med Section Rendering API (sections/dg-maxton-data.liquid), 16 per sida, "Visa fler" hämtar nästa:
    med vald bil:   märkessidan med bilens filter, leverantören och de valda kategoriernas produkttyper (en källa)
    utan bil, val:  varje vald kategorisida med leverantörsfiltret (en källa per kategori, i bollarnas ordning).
                    Maxton Design har över 5 000 produkter, och då filtrerar Shopify inte kollektionen.
    utan bil:       kollektionen själv (Liquid-listan, "Visa fler" fortsätter där).
  Samma filter som dg-bilval.js: bara märke valt = märkesfiltret, annars bilens SEL-ID.

*/
(function () {
  if (window.__dgMaxton) return;
  window.__dgMaxton = true;

  var SEL = 'filter.p.m.custom.sel_ids';
  var MARKE = 'filter.p.m.custom.bilmarke';
  var LEV = 'filter.p.vendor';
  var TYP = 'filter.p.product_type';
  var PER_SIDA = 16; // som paginate i dg-maxton-data
  var rot = document.documentElement;

  // ---------- Hjälp ----------
  function lasBil() { try { return JSON.parse(window.localStorage.getItem('dg_bilval')); } catch (e) { return null; } }
  function harBil(b) { return !!(b && b.steg && b.steg.length && b.sel && b.sel.length); }
  function baraMarke(b) { return b.steg.length === 1 && !Object.keys(b.val || {}).length; }
  function slugga(s) {
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function bilFilter(b) { return baraMarke(b) ? [[MARKE, b.steg[0]]] : b.sel.map(function (s) { return [SEL, s]; }); }
  function etiketter(b) { return b.etiketter && b.etiketter.length ? b.etiketter : b.steg; }
  function kortNamn(b) { return etiketter(b).slice(0, 2).join(' '); }
  function adress(bas, par) {
    var u = new URL(bas, location.origin);
    par.forEach(function (p) { u.searchParams.append(p[0], p[1]); });
    return u.pathname + u.search;
  }
  // Leverantören från heron eller kategorierna. Tomt = alla leverantörer (t.ex. Exteriör).
  function leverantor() {
    var h = document.querySelector('[data-dgm-hero]') || document.querySelector('[data-dgm-kat]');
    return h ? (h.getAttribute('data-leverantor') || '') : 'Maxton Design';
  }
  // Märkessidan med bilens filter och leverantören, t.ex. /collections/bmw?filter.p.m.custom.sel_ids=SEL-000432&filter.p.vendor=Maxton+Design
  function bilAdress(b) {
    var lev = leverantor();
    return adress('/collections/' + (b.samling || slugga(b.steg[0])), bilFilter(b).concat(lev ? [[LEV, lev]] : []));
  }
  function varje(sel, f) { Array.prototype.forEach.call(document.querySelectorAll(sel), f); }
  function tal(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  function antalText(mall, n) {
    var t = mall.replace('{antal}', tal(n));
    return n === 1 ? t.replace(' delar ', ' del ') : t;
  }

  // ---------- Hämtning ----------
  var cache = {};
  function hamtaSida(bas, sida) {
    var url = adress(bas, [['section_id', 'dg-maxton-data'], ['page', String(sida)]]);
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('Maxton-data ' + r.status); return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var j = d.querySelector('[data-dgm-data]');
          if (!j) throw new Error('Maxton-data saknas');
          var data = JSON.parse(j.textContent);
          data.kort = Array.prototype.slice.call(d.querySelectorAll('[data-dgm-kort] > li'));
          return data;
        });
      cache[url].catch(function () { delete cache[url]; });
    }
    return cache[url];
  }

  // ---------- Kategoribollarna ----------
  var valda = [];      // intryckta kategorier (kategorisidornas handles), i bollarnas ordning
  var bilTyper = null; // vald bils produkttyper: {'frontsplitter': {v: 'Frontsplitter', n: 8}, …}
  // Läget "sida" (sections/dg-maxton-bollar.liquid, underkategorier under 5 000 produkter): bollarna filtrerar den
  // här sidan med Shopifys filter Produkttyp (filter.p.product_type i adressen). Bilfiltret står redan i adressen
  // (dg-bilval.js), så antal och produkter gäller bilen utan att något hämtas från märkessidan.
  var SIDA = false, andrat = false, startad = false;
  function sidBas(utanTyper) {
    var u = new URL(location.href);
    ['page', 'kat', 'section_id'].forEach(function (k) { u.searchParams.delete(k); });
    if (utanTyper) u.searchParams.delete(TYP);
    return u.pathname + u.search;
  }

  function bollar() { return Array.prototype.slice.call(document.querySelectorAll('[data-dgm-boll]:not([data-dgm-boll="alla"])')); }
  function boll(h) {
    for (var i = 0, l = bollar(); i < l.length; i++) if (l[i].getAttribute('data-dgm-boll') === h) return l[i];
    return null;
  }
  function ordna() {
    valda = bollar().map(function (li) { return li.getAttribute('data-dgm-boll'); })
      .filter(function (h) { return valda.indexOf(h) > -1; });
  }
  // Bollens produkttyper som filter för vald bil (bara typer som bilen har delar i).
  function typPar(li) {
    if (SIDA) { // sidans egna typvärden, exakt som Shopify vill ha dem
      try { return JSON.parse(li.getAttribute('data-typvarden') || '[]').map(function (v) { return [TYP, v]; }); } catch (e) { return []; }
    }
    var sok = [], par = [];
    try { sok = JSON.parse(li.getAttribute('data-typer') || '[]'); } catch (e) {}
    sok.forEach(function (t) {
      var x = bilTyper && bilTyper[t];
      if (x && x.n) par.push([TYP, x.v]);
    });
    return par;
  }
  function ritaBollar() {
    varje('[data-dgm-boll]', function (li) {
      var h = li.getAttribute('data-dgm-boll'), knapp = li.querySelector('[data-dgm-val]');
      var pa = h === 'alla' ? !valda.length : valda.indexOf(h) > -1;
      if (knapp) knapp.setAttribute('aria-pressed', pa ? 'true' : 'false');
    });
  }
  function sparaIAdress() {
    try {
      var u = new URL(location.href);
      if (SIDA) {
        u.searchParams.delete(TYP);
        u.searchParams.delete('page');
        valda.forEach(function (h) { var li = boll(h); if (li) typPar(li).forEach(function (p) { u.searchParams.append(p[0], p[1]); }); });
      } else if (valda.length) u.searchParams.set('kat', valda.join(','));
      else u.searchParams.delete('kat');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function valj(h) {
    andrat = true;
    if (h === 'alla') valda = [];
    else {
      var i = valda.indexOf(h);
      if (i > -1) valda.splice(i, 1); else valda.push(h);
      ordna();
    }
    ritaBollar();
    sparaIAdress();
    laddaLista();
  }

  // ---------- Produktlistan ----------
  var kallor = []; // [{bas, sida, sidor}]
  var sett = {};   // produkter som visas (inga dubbletter mellan sidor)
  var listNr = 0;

  function prodEl() { return document.querySelector('[data-dgm-prod]'); }
  function nyaKallor(b, p) {
    if (SIDA) {
      var typer = [];
      valda.forEach(function (h) { var li = boll(h); if (li) typer = typer.concat(typPar(li)); });
      return [{ bas: adress(sidBas(true), typer) }];
    }
    if (harBil(b)) {
      var par = [];
      valda.forEach(function (h) { var li = boll(h); if (li) par = par.concat(typPar(li)); });
      return [{ bas: adress(bilAdress(b), par) }];
    }
    if (valda.length) {
      return valda.map(function (h) { var li = boll(h); return li && { bas: li.getAttribute('data-url') }; }).filter(Boolean);
    }
    return [{ bas: p.getAttribute('data-url') }];
  }
  function merFinns() { return kallor.some(function (k) { return k.sida < k.sidor; }); }
  function laggTill(lista, kort) {
    var nya = 0;
    taBortSkelett(lista);
    kort.forEach(function (li) {
      var a = li.querySelector('a'), k = a ? a.getAttribute('href') : String(Math.random());
      if (sett[k]) return;
      sett[k] = true;
      var ny = document.importNode(li, true);
      ny.classList.add('is-ny'); // tonar in, lite förskjutet (CSS --dgm-i)
      ny.style.setProperty('--dgm-i', String(Math.min(nya, 11)));
      lista.appendChild(ny);
      nya++;
    });
    return nya;
  }

  // ---------- Laddning (Tim 2026-10-11: "animation för varje val … som laddar") ----------
  // Platshållarkort som skimrar, ett band under listans rubrik och en snurrande ring på intryckta bollar.
  function skelett(lista, n) {
    for (var i = 0; i < n; i++) {
      var li = document.createElement('li');
      li.className = 'dg-maxton-skelett';
      li.setAttribute('aria-hidden', 'true');
      li.innerHTML = '<span class="dg-maxton-skelett__bild"></span><span class="dg-maxton-skelett__rad"></span><span class="dg-maxton-skelett__rad dg-maxton-skelett__rad--kort"></span>';
      lista.appendChild(li);
    }
  }
  function taBortSkelett(lista) { varje('.dg-maxton-skelett', function (li) { if (li.parentNode === lista) lista.removeChild(li); }); }
  function laddar(p, pa) {
    p.classList.toggle('is-laddar', pa);
    varje('[data-dgm-kat]', function (k) { k.classList.toggle('is-laddar', pa); });
  }
  function satAntal(p, n) {
    var el = p.querySelector('[data-dgm-prod-antal]');
    if (el) el.textContent = tal(n) + (n === 1 ? ' produkt' : ' produkter');
  }
  function ritaHuvud(p, b, kallorNu) {
    var r = p.querySelector('[data-dgm-prod-rubrik]');
    if (r) {
      if (valda.length) r.textContent = valda.map(function (h) { var li = boll(h); return li ? li.getAttribute('data-namn') : ''; }).filter(Boolean).join(' · ');
      else if (harBil(b) && !SIDA) r.textContent = r.getAttribute('data-med').replace('{bil}', kortNamn(b));
      else r.textContent = r.getAttribute('data-utan');
    }
    var rensa = p.querySelector('[data-dgm-rensa]');
    if (rensa) rensa.hidden = !valda.length;
    var alla = p.querySelector('[data-dgm-alla-lank]');
    if (alla) alla.setAttribute('href', kallorNu.length === 1 ? kallorNu[0].bas : p.getAttribute('data-url'));
  }

  function laddaLista() {
    var p = prodEl();
    if (!p) return;
    var b = lasBil(), mitt = ++listNr;
    var lista = p.querySelector('[data-dgm-lista]');
    var status = p.querySelector('[data-dgm-prod-status]');
    var fler = p.querySelector('[data-dgm-fler]');
    var nu = nyaKallor(b, p);
    ritaHuvud(p, b, nu);

    // Startläget: Liquid-listan står kvar, "Visa fler" fortsätter efter den. Utan bil och utan val, eller i läget
    // "sida" innan kunden har tryckt (Liquid har då redan ritat sidan med adressens filter).
    var startlage = SIDA ? !andrat : (!harBil(b) && !valda.length);
    if (startlage && lista.classList.contains('is-liquid')) {
      var start = parseInt(p.getAttribute('data-start'), 10) || 8, antal = parseInt(p.getAttribute('data-antal'), 10) || 0;
      kallor = [{ bas: SIDA ? sidBas(false) : nu[0].bas, sida: Math.floor(start / PER_SIDA), sidor: Math.ceil(antal / PER_SIDA) }];
      sett = {};
      varje('[data-dgm-lista] > li a', function (a) { sett[a.getAttribute('href')] = true; });
      satAntal(p, antal);
      status.hidden = true;
      fler.hidden = !merFinns();
      return;
    }

    lista.classList.remove('is-liquid');
    kallor = nu;
    sett = {};
    lista.innerHTML = '';
    lista.setAttribute('aria-busy', 'true');
    skelett(lista, window.matchMedia('(max-width: 760px)').matches ? 4 : 8);
    laddar(p, true);
    status.hidden = false;
    status.classList.add('is-dold'); // läses upp, men platshållarna visar laddningen
    status.textContent = status.getAttribute('data-laddar');
    fler.hidden = true;

    Promise.all(kallor.map(function (k) { return hamtaSida(k.bas, 1); })).then(function (svar) {
      if (mitt !== listNr) return;
      var summa = 0;
      svar.forEach(function (d, i) {
        kallor[i].sida = 1;
        kallor[i].sidor = d.sidor || 1;
        summa += d.antal || 0;
        laggTill(lista, d.kort);
      });
      lista.removeAttribute('aria-busy');
      taBortSkelett(lista);
      laddar(p, false);
      status.classList.remove('is-dold');
      satAntal(p, summa);
      status.hidden = !!summa;
      if (!summa) status.textContent = status.getAttribute('data-tom');
      fler.hidden = !merFinns();
    }).catch(function (e) {
      if (mitt !== listNr) return;
      if (window.console) console.error(e);
      lista.removeAttribute('aria-busy');
      taBortSkelett(lista);
      laddar(p, false);
      status.classList.remove('is-dold');
      status.hidden = false;
      status.textContent = status.getAttribute('data-fel');
    });
  }

  function visaFler(fler) {
    var p = prodEl();
    if (!p) return;
    var k = kallor.filter(function (x) { return x.sida < x.sidor; })[0];
    if (!k) { fler.hidden = true; return; }
    var mitt = listNr, text = fler.textContent, lista = p.querySelector('[data-dgm-lista]');
    fler.disabled = true;
    fler.textContent = 'Hämtar …';
    if (!lista.querySelector('.dg-maxton-skelett')) skelett(lista, window.matchMedia('(max-width: 760px)').matches ? 2 : 4);
    laddar(p, true);
    hamtaSida(k.bas, k.sida + 1).then(function (d) {
      if (mitt !== listNr) return;
      k.sida += 1;
      k.sidor = d.sidor || k.sidor;
      var nya = laggTill(lista, d.kort);
      laddar(p, false);
      fler.disabled = false;
      fler.textContent = text;
      fler.hidden = !merFinns();
      if (!nya && merFinns()) visaFler(fler); // bara dubbletter: ta nästa sida direkt
    }).catch(function (e) {
      if (window.console) console.error(e);
      taBortSkelett(lista);
      laddar(p, false);
      fler.disabled = false;
      fler.textContent = text;
    });
  }

  // ---------- Vald bil ----------
  var ritNr = 0;
  function rita() {
    if (SIDA) { // bilbyte laddar om sidan (dg-bilval.js); här ritas bara startläget
      if (!startad) { ritaBollar(); laddaLista(); }
      return;
    }
    var b = lasBil(), mitt = ++ritNr;
    if (!harBil(b)) {
      rot.classList.remove('dg-maxton-bil');
      bilTyper = null;
      varje('[data-dgm-boll]', function (li) {
        var n = li.querySelector('[data-dgm-antal]');
        li.hidden = false;
        if (n) n.hidden = true;
      });
      // Kategorier som bara visas med bil släpps.
      valda = valda.filter(function (h) { var li = boll(h); return li && !li.hasAttribute('data-dgm-bara-med'); });
      ritaBollar();
      sparaIAdress();
      laddaLista();
      return;
    }

    rot.classList.add('dg-maxton-bil');
    var namn = etiketter(b), bas = bilAdress(b);
    varje('[data-dgm-bilnamn]', function (el) { el.textContent = namn.join(' '); });
    varje('[data-dgm-mall]', function (el) { el.textContent = el.getAttribute('data-dgm-mall').replace('{bil}', kortNamn(b)); });
    varje('[data-dgm-bil-lank]', function (a) { a.setAttribute('href', bas); });
    varje('[data-dgm-tom-dold]', function (el) { el.hidden = false; });
    varje('[data-dgm-status]', function (el) {
      el.classList.add('is-laddar');
      el.classList.remove('is-tom');
      el.querySelector('[data-dgm-status-text]').textContent = el.getAttribute('data-laddar');
    });
    varje('[data-dgm-antal]', function (n) { n.hidden = true; });

    hamtaSida(bas, 1).then(function (data) {
      if (mitt !== ritNr) return;
      var antal = data.antal || 0;
      bilTyper = {};
      (data.typer || []).forEach(function (t) { bilTyper[String(t.v).toLowerCase()] = t; });

      // Heron
      varje('[data-dgm-status]', function (el) {
        el.classList.remove('is-laddar');
        el.classList.toggle('is-tom', !antal);
        el.querySelector('[data-dgm-status-text]').textContent = antal ? antalText(el.getAttribute('data-mall'), antal) : el.getAttribute('data-tom');
      });
      varje('[data-dgm-tom-dold]', function (el) { el.hidden = !antal; });

      // Bollarna: antal, och kategorier utan delar till bilen döljs.
      varje('[data-dgm-boll]', function (li) {
        var n = li.querySelector('[data-dgm-antal]');
        if (li.getAttribute('data-dgm-boll') === 'alla') {
          if (n) { n.textContent = tal(antal); n.hidden = false; }
          return;
        }
        var summa = 0;
        typPar(li).forEach(function (p) { summa += bilTyper[String(p[1]).toLowerCase()].n; });
        li.hidden = !summa;
        if (n) { n.textContent = tal(summa); n.hidden = !summa; }
      });
      valda = valda.filter(function (h) { var li = boll(h); return li && !li.hidden; });
      ritaBollar();
      sparaIAdress();
      laddaLista();
    }).catch(function (e) {
      if (mitt !== ritNr) return;
      if (window.console) console.error(e);
      varje('[data-dgm-status]', function (el) {
        el.classList.remove('is-laddar');
        el.querySelector('[data-dgm-status-text]').textContent = 'Se vilka delar som passar din bil';
      });
      laddaLista();
    });
  }

  // ---------- Start ----------
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var knapp = e.target.closest('[data-dgm-val]');
    if (knapp) {
      var li = knapp.closest('[data-dgm-boll]');
      if (li) valj(li.getAttribute('data-dgm-boll'));
      return;
    }
    if (e.target.closest('[data-dgm-rensa]')) { valj('alla'); return; }
    var fler = e.target.closest('[data-dgm-fler]');
    if (fler) visaFler(fler);
  });
  document.addEventListener('dg-bilval:bil', rita);
  // Bilen väljs i bilväljarens panel på landningssidan: stanna här i stället för att gå till märkessidan.
  document.addEventListener('dg-bilval:visa', function (e) {
    if (document.querySelector('[data-dgm-hero]')) e.preventDefault();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) rita(); });
  document.addEventListener('shopify:section:load', rita);

  function start() {
    SIDA = !!document.querySelector('[data-dgm-kat][data-lage="sida"]');
    if (SIDA) {
      // Intryckta enligt adressens filter (Liquid markerar dem med data-vald).
      valda = bollar().filter(function (li) { return li.hasAttribute('data-vald'); }).map(function (li) { return li.getAttribute('data-dgm-boll'); });
    } else {
      try {
        var k = new URL(location.href).searchParams.get('kat');
        if (k) valda = k.split(',').filter(function (h) { return !!boll(h); });
        ordna();
      } catch (e) {}
    }
    ritaBollar();
    rita();
    startad = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
